import Editor from '@ckeditor/ckeditor5-core/src/editor';
import { useEffect, useState } from 'react';
import { Field } from 'api/tasks';
import { VariablesMeta } from 'vendor/ckeditor/react-components/variables';

export const useGetFieldsForVariables = (type: string, editor: Editor) => {
  const [fields, setFields] = useState<Field[] | undefined>(undefined);
  const [nestedFields, setNestedFields] =
    useState<Field[] | undefined>(undefined);

  useEffect(() => {
    if (!type) {
      setFields(undefined);
    }

    if (editor?.config?.get('variablesMeta')) {
      switch (type) {
        case 'AUTOMATIONS': {
          const {
            fields: _fields,
            nestedFields: _nestedFields,
          }: VariablesMeta = editor.config.get('variablesMeta');

          setFields(_fields);
          setNestedFields(_nestedFields);
          break;
        }

        default:
          break;
      }
    }
  }, [type, setFields, editor.config]);

  return { fields, nestedFields };
};
